:host {
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
}

a {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  padding: 2rem;
  border: 3px solid rgba(50,62,72,1);
  background-color: rgba(26,196,118,0);
  transition: all 150ms ease-in;
  overflow: hidden;
  cursor: pointer;
  color: var(--cwc-color-accent-b, #008EAA);
  text-decoration: none !important;
}

a:hover {
  border: 3px solid rgba(50,62,72,0);
  color: var(--cwc-color-white, #fff);
  background-color: rgba(26,196,118,1);
}

a > * {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.content {
  margin-left: 0;
  margin-right: auto;
}

.content h2 {
  font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
  font-weight: 400;
  font-size: 28px !important;
  line-height: 38.64px;
  border: unset !important;
  padding: unset !important;
  margin-top: 0;
  margin-bottom: 0;
}

img {
  border-radius: 0;
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.icon {
  width: 64px;
  height: auto;
  border-radius: 0;
}

.arrow {
  width: 48px;
  height: auto;
  transition: all 150ms ease-in;
}

a:hover .arrow {
  transform: translateX(15px);
}

@media screen and (min-width: 640px) {
  a {
    flex-direction: row;
  }

  a .icon {
    margin-right: 2rem;
  }

  a .arrow {
    margin-left: 2rem;
  }
}
